/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_DeniedInputs */

const th_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนถูกบล็อก อนุญาตสำหรับเว็บไซต์นี้ในการตั้งค่าเบราว์เซอร์ของคุณ`)
};

const en_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are blocked. Allow them for this site in your browser settings.`)
};

const ja_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知がブロックされています。ブラウザの設定でこのサイトに許可してください。`)
};

const zh_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知已被阻止。请在浏览器设置中为本站点允许通知。`)
};

const es_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notificaciones están bloqueadas. Permítelas para este sitio en los ajustes de tu navegador.`)
};

const pt_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As notificações estão bloqueadas. Permita-as para este site nas configurações do navegador.`)
};

const id_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi diblokir. Izinkan untuk situs ini di pengaturan peramban Anda.`)
};

const fr_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications sont bloquées. Autorisez-les pour ce site dans les réglages de votre navigateur.`)
};

const tl_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naka-block ang mga notipikasyon. Payagan ang mga ito para sa site na ito sa mga setting ng browser mo.`)
};

const vi_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo bị chặn. Hãy cho phép với trang này trong thiết lập trình duyệt.`)
};

const ko_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`알림이 차단되어 있습니다. 브라우저 설정에서 이 사이트에 허용하세요.`)
};

const de_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen sind blockiert. Erlaube sie für diese Seite in den Browsereinstellungen.`)
};

const ru_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления заблокированы. Разрешите их для этого сайта в настройках браузера.`)
};

const tr_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildirimler engellendi. Tarayıcı ayarlarınızdan bu siteye izin verin.`)
};

const it_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le notifiche sono bloccate. Consentile per questo sito nelle impostazioni del browser.`)
};

const pl_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia są zablokowane. Zezwól na nie dla tej strony w ustawieniach przeglądarki.`)
};

const uk_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення заблоковано. Дозвольте їх для цього сайту в налаштуваннях браузера.`)
};

const hi_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सूचनाएँ अवरुद्ध हैं। अपने ब्राउज़र की सेटिंग्स में इस साइट के लिए अनुमति दें।`)
};

const ar_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات محظورة. اسمح بها لهذا الموقع من إعدادات متصفحك.`)
};

const ms_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan disekat. Benarkannya untuk laman ini dalam tetapan pelayar anda.`)
};

const bn_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বিজ্ঞপ্তি আটকানো আছে। ব্রাউজারের সেটিংসে এই সাইটের জন্য অনুমতি দিন।`)
};

const zh_tw2_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知已被封鎖。請在瀏覽器設定中允許本網站。`)
};

const zh_hk2_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通知已被封鎖。請在瀏覽器設定中允許本網站。`)
};

const ur_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلاعات روکی گئی ہیں۔ براؤزر کی ترتیبات میں اس سائٹ کے لیے اجازت دیں۔`)
};

const fa_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌ها مسدود شده‌اند. در تنظیمات مرورگر برای این سایت اجازه دهید.`)
};

const sw_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa zimezuiwa. Ziruhusu kwa tovuti hii kwenye mipangilio ya kivinjari chako.`)
};

const nl_push_denied = /** @type {(inputs: Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen zijn geblokkeerd. Sta ze toe voor deze site in je browserinstellingen.`)
};

/**
* | output |
* | --- |
* | "Notifications are blocked. Allow them for this site in your browser settings." |
*
* @param {Push_DeniedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_denied = /** @type {((inputs?: Push_DeniedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_DeniedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_denied(inputs)
	if (locale === "ja") return ja_push_denied(inputs)
	if (locale === "zh") return zh_push_denied(inputs)
	if (locale === "es") return es_push_denied(inputs)
	if (locale === "pt") return pt_push_denied(inputs)
	if (locale === "id") return id_push_denied(inputs)
	if (locale === "fr") return fr_push_denied(inputs)
	if (locale === "tl") return tl_push_denied(inputs)
	if (locale === "vi") return vi_push_denied(inputs)
	if (locale === "ko") return ko_push_denied(inputs)
	if (locale === "de") return de_push_denied(inputs)
	if (locale === "ru") return ru_push_denied(inputs)
	if (locale === "tr") return tr_push_denied(inputs)
	if (locale === "it") return it_push_denied(inputs)
	if (locale === "pl") return pl_push_denied(inputs)
	if (locale === "uk") return uk_push_denied(inputs)
	if (locale === "hi") return hi_push_denied(inputs)
	if (locale === "ar") return ar_push_denied(inputs)
	if (locale === "ms") return ms_push_denied(inputs)
	if (locale === "bn") return bn_push_denied(inputs)
	if (locale === "zh-TW") return zh_tw2_push_denied(inputs)
	if (locale === "zh-HK") return zh_hk2_push_denied(inputs)
	if (locale === "ur") return ur_push_denied(inputs)
	if (locale === "fa") return fa_push_denied(inputs)
	if (locale === "sw") return sw_push_denied(inputs)
	if (locale === "nl") return nl_push_denied(inputs)
	return en_push_denied(inputs)
});